const pick = (...values) => values.find((value) => value != null) ?? null;

export function resolveVariantIds({
  item,
  variantMatrix,
  selectedColorOption,
  selectedSizeOption,
  selectedColor,
  selectedSize,
}) {
  const matrix = variantMatrix ?? {};
  const byColorAndSize = matrix[`${selectedColor}::${selectedSize}`];
  const byColorOnly = matrix[`${selectedColor}::`];
  const bySizeOnly = matrix[`::${selectedSize}`];

  return {
    variantId: pick(
      byColorAndSize?.variantId,
      byColorOnly?.variantId,
      bySizeOnly?.variantId,
      selectedSizeOption?.variantId,
      selectedColorOption?.variantId,
      item?.variantId
    ),
    variationId: pick(
      byColorAndSize?.variationId,
      byColorOnly?.variationId,
      bySizeOnly?.variationId,
      selectedSizeOption?.variationId,
      selectedColorOption?.variationId,
      item?.variationId
    ),
  };
}

const sameId = (a, b) => String(a ?? "") === String(b ?? "");

export function isVariantInList(
  existingItems,
  stockId,
  variationId,
  variantId
) {
  if (!Array.isArray(existingItems)) return false;

  return existingItems.some(
    (existing) =>
      sameId(existing?.stockId ?? existing?.productId, stockId) &&
      sameId(existing?.variationId, variationId) &&
      sameId(existing?.variantId, variantId)
  );
}
